import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import select from '../../../images/select.svg';

const VisualisationInput = styled.div`
  position: relative;
  &:after{
    content: " ";
    position: absolute;
    display: block;
    z-index: 10;
    width: 45px;
    height: 45px;
    right: 0;
    top: 0;
    background-image: url(${select});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px;
    border: 1px solid #aaaaaa:;
    border-left: none;
    pointer-events: none;
  }
`;

const Input = styled.input`
  background-color: #e8e8e8;
  margin-bottom: 0 !important;
`;

const Result = styled.div`
  cursor: pointer;
  background-color: #ffffff;
  border-bottom: 1px solid #aaaaaa;
  border-right: 1px solid #aaaaaa;
  border-left: 1px solid #aaaaaa;
  padding: 9px 10px;
  &:hover{
    background-color: #f5f5f5;
  }
  p{
    margin-bottom: 0;
  }
`;

const ResultList = styled.div`
  max-height: 400px;
  overflow: auto;
  position: absolute;
  width: 100%;
  z-index: 99;
`;

class Typeahead extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      showSuggestions: false,
    };
  }
  onChange(e) {
    this.setState({
      value: e.target.value || '',
    });
    this.props.getSuggestions(e.target.value);
  }
  onClick(e) {
    this.state.value = e.target.dataset.text;
    this.state.showSuggestions = false;
    this.setState(this.state);
    this.props.onChange(e.target.dataset.text);
  }
  onKeyUp(e) {
    if ([13, 32].includes(e.keyCode)) { // Enter, Space
      this.onClick(e);
    }
  }
  onFocus() {
    this.setState({
      showSuggestions: true,
    });
  }
  render() {
    let suggestions;
    if (this.state.showSuggestions) {
      suggestions = this.props.suggestions.map((s) =>
        <Suggestion key={s.value} value={s.value} text={s.text} onClick={(e) => { this.onClick(e); }} onKeyUp={(e) => this.onKeyUp(e)} />
      );
    }
    return (
      <div>
        <VisualisationInput>
          <Input type="text" value={this.state.value} onChange={(e) => this.onChange(e)} onFocus={() => this.onFocus()} />
        </VisualisationInput>
        <ResultList>
          {suggestions}
        </ResultList>
      </div>
    );
  }
}

Typeahead.propTypes = {
  value: PropTypes.string,
  suggestions: PropTypes.array,
  getSuggestions: PropTypes.func,
  onChange: PropTypes.func,
};

export default Typeahead;

const Suggestion = (props) => (
  <Result onClick={props.onClick} data-value={props.value} data-text={props.text}>
    <span onClick={props.onClick} data-value={props.value} data-text={props.text} role="button" tabIndex="0" onKeyUp={props.onKeyUp}>{props.text}</span>
  </Result>
);

Suggestion.propTypes = {
  onClick: PropTypes.func,
  onKeyUp: PropTypes.func,
  value: PropTypes.number,
  text: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/components/FormControls/Visualisation/Typeahead.js